define("shared/utils/array-filters/get-last-value", ["exports", "@ember/utils"], function (_exports, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getLastValue = _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils"eaimeta@70e063a35619d71f
  /**
   * Extracts a value from a provided array of object at the specified
   * `keyName` for the object with the most recent `time` property.
   *
   * @param data Array of objects to be searched through
   * @param keyName key name of value to return
   *
   * @returns The most recent value from the given data
   */
  const getLastValue = (data, keyName) => {
    if (!data.length) {
      return undefined;
    }
    return data.filter(point => (0, _utils.isPresent)(point[keyName])).reduce((prev, current) => prev.time > current.time ? prev : current, data[0])[keyName];
  };
  _exports.getLastValue = getLastValue;
  var _default = _exports.default = getLastValue;
});